import { jsx as _jsx } from "react/jsx-runtime";
import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { LibraryPage } from '@/features/project-library/LibraryPage';
// ConfiguratorPage carrega three/drei (~260 KB gzip) — separamos em chunk próprio
// para que a biblioteca inicial suba rápida no primeiro paint.
const ConfiguratorPage = lazy(() => import('@/features/mattress-configurator/ConfiguratorPage').then((m) => ({
    default: m.ConfiguratorPage,
})));
const ReceiptPage = lazy(() => import('@/features/receipt/ReceiptPage').then((m) => ({ default: m.ReceiptPage })));
export const routes = [
    { path: '/', element: _jsx(LibraryPage, {}) },
    { path: '/project/:projectId', element: _jsx(ConfiguratorPage, {}) },
    { path: '/receipt/:projectId', element: _jsx(ReceiptPage, {}) },
    { path: '*', element: _jsx(Navigate, { to: "/", replace: true }) },
];
